(function(){
    'use strict';

    angular.module('tmx-app')
        .directive('tmxDialog', ['lookupService',tmxDialog]);

    function tmxDialog(lookupService) {

        var directive={
            restrict: 'E',
            scope: {
                model: '=',
                service: '=',
                url:"@",
                onSubmit:"&",
                icon: "@",
                buttonclass: "@",
                iconclass: "@",
                title:"@",
                buttonstyle: "@",
                iconstyle:"@",
                disable: "="
            },

            templateUrl: 'common/directives/dialog/dialog.html',
            controller: ["$scope","$mdDialog","lookupService",tmxDialogCtrl],
            controllerAs:'tmxDialogCtrl'
        };
      
        return directive; 
    }

    function tmxDialogCtrl($scope,$mdDialog,lookupService){
        var dialog=this;
        dialog.scope=$scope;
      // var tmxResource = tmxResource;
        dialog.showDialog=function(){
            showDialog(dialog,$mdDialog,lookupService);
        }

    }

    function showDialog(dialog,$mdDialog,lookupService){
        var vm=angular.copy(dialog.scope.model);
      
      
      //var vm=dialog.scope.model;
        var tempUrl;
      

        if(angular.isDefined(dialog.scope.url))
            tempUrl = dialog.scope.url;
        else
            tempUrl = 'common/directives/dialog/dialog-tmpl.html';
        dialog.scope.result=vm;
        var dialogParam={
            model:vm,
            title:dialog.scope.title
        };
        $mdDialog.show({
            controller: ["$scope","$mdDialog","params","lookupService","LocationTreeService", dialogCtrl],
            controllerAs: "dialogCtrl",
            templateUrl: tempUrl,
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            locals:{params:dialogParam}
        }).then(function(result){

        
            if(angular.isDefined(result)) {
                if(dialog.scope.result.action==="New") {
                    var arr = [];
                    for(var i=0; i<result.length; i++) {
                        arr.push(result[i]);
                    }
                    dialog.scope.result.TmXCustomerSite = arr;
              
                }
                else if(dialog.scope.result.action==="Edit") {
                    var add_array = [];
                    var edit_array = [];
                    var del_array = [];
                    for(var i=0; i<result.length; i++) {
                        if(result[i].action==="Edit") {
                            edit_array.push(result[i]);
                        }
                        else if(result[i].action==="New") {
                            result[i].CustomerMasterId = dialog.scope.result.CustomerMasterId;
                            add_array.push(result[i]);
                        }
                        else if(result[i].action==="Delete")
                            del_array.push(result[i]);
                    }
            //call site add on add_array
                    if(edit_array.length>0)
                        dialog.scope.service.Update(dialog.scope.result.CustomerMasterId,edit_array);
                    if(add_array.length>0)
                        dialog.scope.service.Save(dialog.scope.result.CustomerMasterId,add_array);
                    if(del_array.length>0)
                        dialog.scope.service.Delete(dialog.scope.result.CustomerMasterId,del_array);
                }
            }
          
            // if(angular.isDefined(result.scope.EffectiveEndDate))
            // {
            //   result.scope.EffectiveEndDate = result.scope.EffectiveEndDate.toJSON();
            // }
            dialog.scope.result.$saveOrUpdate().then( function(answer){ 
                dialog.scope.onSubmit({ promise: answer });
            }); 
          
        
        });
    }


    function dialogCtrl($scope,$mdDialog,params,lookupService,LocationTreeService){
       
        var dialog=this;
        dialog.lookup = lookupService;
        dialog.LocationTreeService = LocationTreeService;
        dialog.loading=true;
      // dialog.customerTypeLkp={};
      // var opt=[];
      // for(var i=0; i<lookupService.common.local.CUSTOMER_TYPE.length;i++)
      // {
      //   opt.push({key:lookupService.common.local.CUSTOMER_TYPE[i].VisibleValue ,value:lookupService.common.local.CUSTOMER_TYPE[i].LookupId});
      // }
      // dialog.customerTypeLkp.options=opt;
    
        dialog.select={};
        dialog.select.options=[
            {key:"Private", value:"1"},
            {key:"Public", value:"2"}
        ];

      
        dialog.title=params.title;
        dialog.vm=params.model;
        if(angular.isDefined(dialog.vm.EffectiveEndDate)) {
            dialog.vm.EffectiveEndDate = new Date(dialog.vm.EffectiveEndDate);
            dialog.vm.EffectiveStartDate = new Date(dialog.vm.EffectiveStartDate);
        }
        else
            dialog.vm.EffectiveStartDate = new Date();

        dialog.hide=function(){
            $mdDialog.hide();
        }
        dialog.cancel=function(){
            $mdDialog.cancel();
        }
        dialog.done = function(result) {
            $mdDialog.hide(result);
        }

      // var siteArray = [];
        if(dialog.vm.$id()) {
            dialog.vm.action="Edit";
            dialog.vm.$getDetail().then( function(result){
            // dialog.vm = result;
            // siteArray = vm.TmXCustomerSite;
                if(angular.isDefined(result)) {
                    if(angular.isDefined(result.TmXCustomerSite)) {
                        if(result.TmXCustomerSite.length > 0) {
                            for(var i=0; i<result.TmXCustomerSite.length; i++ ) {
                                dialog.gridData.push(result.TmXCustomerSite[i]);
                                dialog.mainGrid.push(result.TmXCustomerSite[i]);
                            }
                            dialog.loading=false;
                        }
                    }
                }
            });
        }
        else {
            dialog.vm.action="New";
        }
        dialog.loading=false;
        dialog.showSiteAdd = false;
        dialog.CustomerSite = {};
        dialog.evm;

        dialog.gridData = new kendo.data.ObservableArray([
         // {Code: "TEST", Name: "Owais", Latitude:"0", Longitude:"0"}
        ]);

        dialog.mainGrid = new kendo.data.ObservableArray([]);
      

        dialog.addCustomerSite = function() {
        
        // dialog.evm.CustomerMasterId = dialog.vm.CustomerMasterId;
        
            dialog.showSiteAdd = false;
            if(angular.isDefined(dialog.item)){
          //means update
          
                dialog.gridData.remove(dialog.item);
                dialog.evm.action = "Edit";
            }
            else {
                dialog.evm.action="New";
            }
            dialog.gridData.push(dialog.evm);
            dialog.mainGrid.push(dialog.evm);
        }

        dialog.clickDelete = function (item) {            
            DeleteCustomerSite(item);
        }

        dialog.date = new Date().toJSON();
        dialog.isStatusActive=function(dataitem){
            if(dataitem.EffectiveEndDate<dialog.date)return true;
            return false;
        }

        dialog.clickEdit = function (item) {
            dialog.item=item;      
            if(angular.isDefined(dialog.item)) {
                if(angular.isDefined(dialog.item.EffectiveEndDate)) {
                    dialog.item.EffectiveEndDate = new Date(dialog.item.EffectiveEndDate);
                    dialog.item.EffectiveStartDate = new Date(dialog.item.EffectiveStartDate);
                }   
                else
                    dialog.item.EffectiveStartDate = new Date();
            }
            dialog.evm = angular.copy(item);
            dialog.showSiteAdd = true;

        }

        dialog.siteCancel = function (item) {            
            dialog.showSiteAdd = false;
            dialog.evm = {};
        }

        var DeleteCustomerSite = function(tid){
            dialog.gridData.remove(tid); 
            for(var i=0; i<dialog.mainGrid.length; i++) {
                if(dialog.mainGrid[i].CustomerSiteId===tid.CustomerSiteId) {
                    dialog.mainGrid.splice(i, 1);
                }  
            } 
        // dialog.mainGrid.remove(tid);
            tid.action = "Delete";
            dialog.mainGrid.push(tid);
        };


        dialog.gridColumns = [
            {
                field: "SiteName",
                title: "Name",
            },
            {
                field: "ShipToSite",
                title: "Ship To Site"

            },
            {
                field: "PaymentType",
                title: "Payment Type"
            },
            {
                field: "LocationId",
                title: "Location Id",

            },
                            
                           
            {command :[
                {
                    name: "Delete",
                    text: "",
                    template: "<md-button aria-label='del' class='tmxMin' ng-click='dialogCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /> <md-tooltip> Delete Customer Site</md-tooltip></md-button>",
                },
                                 
                {
                    name: "Edit",
                    text: "",
                    template: "<md-button aria-label='del' class='tmxMin' ng-click='dialogCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /> <md-tooltip> Delete Customer Site</md-tooltip></md-button>",
                                      
                }
            ]}
        ];
            

        dialog.detail = new kendo.data.DataSource({ 
            data: dialog.gridData,
            schema: {
                model: {
                    id: "Code",

                    fields: {
                        CustomerSiteId: { type: "number", nullable: true },
                        SiteName: { type: "string"  },
                        ShipToSite: { type: "number" },
                        PaymentType: { type: "string" },
                        LocationId: { type: "number" },
           
            
                    }
                }
            },
             //errors: "error"
         
            pageSize: 10
        });


        dialog.mainGridOptions = {
         // toolbar: ["pdf","excel"],
       
            pdf: {
                allPages: true,
                fileName: "Customers.pdf"
            },
            excel: {
                allPages: true,
                fileName: "Customers.xlsx"
            },
            navigatable: true,
            pageable: true,
            rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': dialogCtrl.isStatusActive(dataItem)}\"><td>#= SiteName # </td><td>#= ShipToSite # </td><td>#= PaymentType # </td><td>#= LocationId # </td><td><md-button ng-disabled='dialogCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='dialogCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /></md-button><md-button ng-disabled='dialogCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='dialogCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /> <md-tooltip> Delete Customer Site</md-tooltip></md-button></td></tr>",
         // height: 250,
         // filterable: true,
         
            editable: {
                mode: "popup",
            // template: kendo.template($("#popup_editor").html())
            }
        };


    }

})();